import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getLearningPaths } from '../../services/learningPaths';
import { Route, Users } from 'lucide-react';

export default function LearningPaths() {
  const [paths, setPaths] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getLearningPaths().then(r => setPaths(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const diffColors = { beginner: 'bg-green-100 text-green-700', intermediate: 'bg-yellow-100 text-yellow-700', advanced: 'bg-red-100 text-red-700' };
  const diffLabels = { beginner: "Boshlang'ich", intermediate: "O'rta", advanced: "Yuqori" };

  if (loading) return <div className="flex items-center justify-center h-64"><div className="animate-spin rounded-full h-8 w-8 border-2 border-blue-500 border-t-transparent"></div></div>;

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-teal-600 to-cyan-600 rounded-2xl p-8 text-white">
        <h1 className="text-3xl font-bold mb-2 flex items-center gap-2"><Route className="w-8 h-8" /> O'quv yo'llari</h1>
        <p className="text-teal-100">Tizimli ravishda o'rganish uchun tayyorlangan yo'nalishlar</p>
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        {paths.map(p => (
          <Link key={p.id} to={`/learning-paths/${p.id}`} className="bg-white dark:bg-gray-800 rounded-2xl p-6 border border-gray-100 dark:border-gray-700 shadow-sm hover:shadow-md hover:border-blue-200 dark:hover:border-blue-700 transition block">
            <div className="flex items-center gap-2 mb-3">
              <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${diffColors[p.difficulty] || 'bg-gray-100'}`}>
                {diffLabels[p.difficulty]}
              </span>
              <span className="text-xs text-gray-400">{p.courses?.length || 0} ta kurs</span>
            </div>
            <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-2">{p.title}</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">{p.description}</p>
            <div className="flex items-center gap-2 text-xs text-gray-400">
              <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5" /> {p.creator?.name}</span>
            </div>
          </Link>
        ))}
      </div>

      {paths.length === 0 && (
        <div className="bg-white rounded-2xl p-12 text-center border border-gray-100">
          <Route className="w-12 h-12 text-gray-300 mx-auto mb-4" />
          <h3 className="text-lg font-bold text-gray-900 mb-2">Hali o'quv yo'llari yo'q</h3>
        </div>
      )}
    </div>
  );
}